import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { env } from '@/env';
import { Icon } from '@/modules/ui';
import { ErrorCode } from '@/services/utilities/isApiError';

import * as felaRules from './LoginErrorMessage.rules';

export interface LoginErrorMessageProps {
    errorCode: ErrorCode | null;
}

export const LoginErrorMessage = ({ errorCode }: LoginErrorMessageProps) => {
    const { css } = useFela(felaRules);

    switch (errorCode) {
        case ErrorCode.AUTH_CLIENT_IS_NOT_CONFIGURED: {
            if (!env.VITE_SAAS) {
                return (
                    <section role='alert' className={css(felaRules.message)}>
                        <Icon type='warning' />
                        <p className={css(felaRules.text)}>
                            <FormattedMessage id='error.auth.clientNotConfigured' />
                        </p>
                    </section>
                );
            }
            return null;
        }
        default:
            return null;
    }
};
